export var pow = function pow(tupledArg) {
  return Math.pow(tupledArg[0], tupledArg[1]);
};
export var sin = function sin(arg00) {
  return Math.sin(arg00);
};
export var cos = function cos(arg00) {
  return Math.cos(arg00);
};
export var pi = Math.PI;
export function sqrlet(t) {
  return function (arg00) {
    return Math.sqrt(arg00);
  };
}
export var asin = function asin(arg00) {
  return Math.asin(arg00);
};
export function linear(t, b, c, d) {
  return c * t / d + b;
}
export function inQuad(t, b, c, d) {
  var t_1 = t / d;
  return c * pow([t_1, 2]) + b;
}
export function outQuad(t, b, c, d) {
  var t_1 = t / d;
  return -c * t_1 * (t_1 - 2) + b;
}
export function inOutQuad(t, b, c, d) {
  var t_1 = t / d * 2;

  if (t_1 < 1) {
    return c / 2 * pow([t_1, 2]) + b;
  } else {
    return -c / 2 * ((t_1 - 1) * (t_1 - 3) - 1) + b;
  }
}
export function inCubic(t, b, c, d) {
  var t_1 = t / d;
  return c * pow([t_1, 3]) + b;
}
export function outCubic(t, b, c, d) {
  var t_1 = t / d - 1;
  return c * (pow([t_1, 3]) + 1) + b;
}
export function inOutCubic(t, b, c, d) {
  var t_1 = t / d * 2;

  if (t_1 < 1) {
    return c / 2 * t_1 * t_1 * t_1 + b;
  } else {
    var t_2 = t_1 - 2;
    return c / 2 * (t_2 * t_2 * t_2 + 2) + b;
  }
}
export function outInCubic(t, b, c, d) {
  return t < d / 2 ? outCubic(t * 2, b, c / 2, d) : inCubic(t * 2 - d, b + c / 2, c / 2, d);
}
export function inQuart(t, b, c, d) {
  var t_1 = t / d;
  return c * pow([t_1, 4]) + b;
}
export function outQuart(t, b, c, d) {
  var t_1 = t / d - 1;
  return -c * (pow([t_1, 4]) - 1) + b;
}
export function inOutQuart(t, b, c, d) {
  var t_1 = t / d * 2;

  if (t_1 < 1) {
    return c / 2 * pow([t_1, 4]) + b;
  } else {
    var t_2 = t_1 - 2;
    return -c / 2 * (pow([t_2, 4]) - 2) + b;
  }
}
export function outInQuart(t, b, c, d) {
  return t < d / 2 ? outQuart(t * 2, b, c / 2, d) : inQuart(t * 2 - d, b + c / 2, c / 2, d);
}
export function inQuint(t, b, c, d) {
  var t_1 = t / d;
  return c * pow([t_1, 5]) + b;
}
export function outQuint(t, b, c, d) {
  var t_1 = t / d - 1;
  return c * (pow([t_1, 5]) + 1) + b;
}
export function inOutQuint(t, b, c, d) {
  var t_1 = t / d * 2;

  if (t_1 < 1) {
    return c / 2 * pow([t_1, 5]) + b;
  } else {
    var t_2 = t_1 - 2;
    return c / 2 * (pow([t_2, 5]) + 2) + b;
  }
}
export function outInQuint(t, b, c, d) {
  return t < d / 2 ? outQuint(t * 2, b, c / 2, d) : inQuint(t * 2 - d, b + c / 2, c / 2, d);
}
export function inSine(t, b, c, d) {
  return -c * cos(t / d * (pi / 2)) + c + b;
}
export function outSine(t, b, c, d) {
  return c * sin(t / d * (pi / 2)) + b;
}
export function inOutSine(t, b, c, d) {
  return -c / 2 * (cos(pi * t / d) - 1) + b;
}
export function outInSine(t, b, c, d) {
  return t < d / 2 ? outSine(t * 2, b, c / 2, d) : inSine(t * 2 - d, b + c / 2, c / 2, d);
}
export function inExpo(t, b, c, d) {
  return t === 0 ? b : c * pow([2, 1 * (t / d - 1)]) + b - c * 0.001;
}
export function outExpo(t, b, c, d) {
  return t === d ? b + c : c * 1.001 * (-pow([2, -1 * t / d]) + 1) + b;
}
export function inOutExpo(t, b, c, d) {
  return t === 0 ? b : t === d ? b + c : function () {
    var t_1 = t / d * 2;

    if (t_1 < 1) {
      return c / 2 * pow([2, 1 * (t_1 - 1)]) + b - c * 0.0005;
    } else {
      var t_2 = t_1 - 1;
      return c / 2 * 1.0005 * (-pow([2, -1 * t_2]) + 2) + b;
    }
  }();
}
export function outInExpo(t, b, c, d) {
  return t < d / 2 ? outExpo(t * 2, b, c / 2, d) : inExpo(t * 2 - d, b + c / 2, c / 2, d);
}
export function inCirc(t, b, c, d) {
  var t_1 = t / d;
  return -c * (Math.sqrt(1 - pow([t_1, 2])) - 1) + b;
}
export function outCirc(t, b, c, d) {
  var t_1 = t / d - 1;
  return c * Math.sqrt(1 - pow([t_1, 2])) + b;
}
export function inOutCirc(t, b, c, d) {
  var t_1 = t / d * 2;

  if (t_1 < 1) {
    return -c / 2 * (Math.sqrt(1 - t_1 * t_1) - 1) + b;
  } else {
    var t_2 = t_1 - 2;
    return c / 2 * (Math.sqrt(1 - t_2 * t_2) + 1) + b;
  }
}
export function outInCirc(t, b, c, d) {
  return t < d / 2 ? outCirc(t * 2, b, c / 2, d) : inCirc(t * 2 - d, b + c / 2, c / 2, d);
}
export function inBack(t, b, c, d, s) {
  var s_1 = s != null ? s : 1.70158;
  var t_1 = t / d;
  return c * t_1 * t_1 * ((s_1 + 1) * t_1 - s_1) + b;
}
export function outBack(t, b, c, d, s) {
  var s_1 = s != null ? s : 1.70158;
  var t_1 = t / d - 1;
  return c * (t_1 * t_1 * ((s_1 + 1) * t_1 + s_1) + 1) + b;
}
export function inOutBack(t, b, c, d, s) {
  var d_1 = s != null ? s : 1.70158;
  var s_1 = d_1 * 1.525;
  var t_1 = t / d_1 * 2;

  if (t_1 < 1) {
    return c / 2 * (t_1 * t_1 * ((s_1 + 1) * t_1 - s_1)) + b;
  } else {
    var t_2 = t_1 - 2;
    return c / 2 * (t_2 * t_2 * ((s_1 + 1) * t_2 + s_1) + 2) + b;
  }
}
export function outInBack(t, b, c, d, s) {
  return t < d / 2 ? outBack(t * 2, b, c / 2, d, s) : inBack(t * 2 - d, b + c / 2, c / 2, d, s);
}
export function outBounce(t, b, c, d) {
  var t_1 = t / d;

  if (t_1 < 1 / 2.75) {
    return c * (7.5625 * t_1 * t_1) + b;
  } else {
    if (t_1 < 2 / 2.75) {
      var t_2 = t_1 - 1.5 / 2.75;
      return c * (7.5625 * t_2 * t_2 + 0.75) + b;
    } else {
      if (t_1 < 2.5 / 2.75) {
        var _t_ = t_1 - 2.25 / 2.75;

        return c * (7.5625 * _t_ * _t_ + 0.9375) + b;
      } else {
        var _t_2 = t_1 - 2.625 / 2.75;

        return c * (7.5625 * _t_2 * _t_2 + 0.984375) + b;
      }
    }
  }
}
export function inBounce(t, b, c, d) {
  return c - outBounce(d - t, 0, c, d) + b;
}
export function inOutBounce(t, b, c, d) {
  return t < d / 2 ? inBounce(t * 2, 0, c, d) * 0.5 + b : outBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
}
export function outInBounce(t, b, c, d) {
  return t < d / 2 ? outBounce(t * 2, b, c / 2, d) : inBounce(t * 2 - d, b + c / 2, c / 2, d);
}